// This file was automatically generated from ptdata.model.dcMedOrder.html.
// Please don't edit this file by hand.

goog.provide('el8.template.ptdata.model.dcMedOrder');

goog.require('soy');
goog.require('soy.StringBuilder');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.noteSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isDocumented) ? 'Doc\'d ' : '', 'D/C ', soy.$$escapeHtml(opt_data.displayedMedicationName), (opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '', (opt_data.reason) ? ' because: ' + soy.$$escapeHtml(opt_data.reason) : '', (! opt_data.dcOnDocumentDate) ? ' (discontinued on ' + (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.discontinueDate)) : '') + ')' : '', (opt_data.documentedOtherPrescriberName) ? ' (' + soy.$$escapeHtml(opt_data.documentedOtherPrescriberName) + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.orderSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<span class="el8TagItem mr5">', (opt_data.isDocumented) ? 'Doc\'d ' : '', 'D/C</span>', (opt_data.feedItemId) ? '<a class="details-trigger" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' + ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) + ((opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '') + '</a>' : (opt_data.hasTrigger) ? '<a class="details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' + ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) + ((opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '') + '</a>' : ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) + ((opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.orderSummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isDocumented) ? 'Doc\'d' : '', ' D/C: ', (opt_data.feedItemId) ? '<a class="details-trigger" _fid="' + soy.$$escapeHtml(opt_data.feedItemId) + '">' + ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) + ((opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '') + '</a>' : (opt_data.hasTrigger) ? '<a class="details-trigger" data-id="' + soy.$$escapeHtml(opt_data.id) + '">' + ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) + ((opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '') + '</a>' : ((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) + ((opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : ''));
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.orderDetailedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.dcMedOrder.orderSummary(opt_data, output);
  output.append((opt_data.reason) ? ' because: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.reason)) : soy.$$escapeHtml(opt_data.reason)) : '', (! opt_data.dcOnDocumentDate) ? ' (discontinued on ' + (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.discontinueDate)) : '') + ', documented on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.signDate)) : '') + ')' : '', (opt_data.documentedOtherPrescriberName) ? ' <span class="el8AppColor">(' + soy.$$escapeHtml(opt_data.documentedOtherPrescriberName) + ')</span>' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.feedReasonAndDateNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.reason) ? ' Reason: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.reason)) : soy.$$escapeHtml(opt_data.reason)) : '', (! opt_data.dcOnDocumentDate) ? ' (discontinued on ' + (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.discontinueDate)) : '') + ', documented on ' + (soy.$$escapeHtml(opt_data.signDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.signDate)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.feedSummary = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<p class="el8FeedItemHeader">');
  el8.template.ptdata.model.dcMedOrder.orderDetailedSummary(opt_data, output);
  output.append('<span class="el8SystemText el8LeftIndent">-- ', soy.$$escapeHtml(opt_data.documentingPersonnelName), (opt_data.supervisingPhysicianName) ? ' - Supervisor: ' + soy.$$escapeHtml(opt_data.supervisingPhysicianName) : '', '</span></p>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.feedSummaryNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  el8.template.ptdata.model.dcMedOrder.orderSummaryNew(opt_data, output);
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.feedSourceNew = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8FeedColSourceTopLine">', soy.$$escapeHtml(opt_data.documentingPersonnelName), '</div><div class="el8FeedColSourceLine">', (opt_data.supervisingPhysicianName) ? ' Suprv: ' + soy.$$escapeHtml(opt_data.supervisingPhysicianName) : '', '</div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.chartFeedIcon = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isDocumentMed) ? '<div class="el8FeedItemIconDCDocMed"></div>' : '<div class="el8FeedItemIconDCRx"></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.ownedDocSummaryType = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.isPatientFriendly) ? 'Discontinue' : ((opt_data.isDocumented) ? 'Doc\'d ' : '') + 'D/C');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.ownedDocSummaryDescription = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.highlight) ? (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName)) : soy.$$escapeHtml(opt_data.displayedMedicationName), (opt_data.directions) ? ' ' + soy.$$escapeHtml(opt_data.directions) : '', (opt_data.reason) ? ' because: ' + (el8.appservice && el8.appservice.highlighter ? el8.appservice.highlighter.highlightText(soy.$$escapeHtml(opt_data.reason)) : soy.$$escapeHtml(opt_data.reason)) : '', (! opt_data.dcOnDocumentDate) ? ' (discontinued on ' + (soy.$$escapeHtml(opt_data.discontinueDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.discontinueDate)) : '') + ')' : '');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.ptdata.model.dcMedOrder.ownedDocSummaryOtherPrescriber = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append((opt_data.documentedOtherPrescriberName) ? ' (' + soy.$$escapeHtml(opt_data.documentedOtherPrescriberName) + ')' : '');
  if (!opt_sb) return output.toString();
};
